module.exports = __webpack_public_path__ + "public/SiteIcons/expandIcon.svg?9896c649";